import React, { useState, useEffect } from 'react';
import { string, number, func, bool } from 'prop-types';
import { ALERT_TYPE, DATA_TAGGER_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import '@laramie/ui/dist/components/controls/DataTaggerModalApi/index.css';
import { APIS } from '../../../config/apis';
import { ServerRequest } from '../../../utils/apiweb';
import { DataTagger, Loading, Modal } from '../../common';



const DataTaggerModalApi = (props) => {

  //hooks
  const [state, setState] = useState({
    loading: false,
    entidad: "",
    idEntidad: 0,
    data: {
      archivos: [],
      observaciones: [],
      etiquetas: []
    }
  });

  const [controllerDataTagger, setControllerDataTagger] = useState({
    entidad: "",
    idEntidad: 0,
    data: {
      archivos: [],
      observaciones: [],
      etiquetas: []
    },
    addRow: (dataTaggerType, row, success, error) => {},
    removeRow: (dataTaggerType, row, success, error) => {}
  });

  const mount = () => {

    if (props.idEntidad > 0) {
      SearchInformacionAdicional();
    }

  }
  useEffect(mount, [props.entidad, props.idEntidad]);

  useEffect(() => {
    setControllerDataTagger({
      entidad: state.entidad,
      idEntidad: state.idEntidad,
      data: {
          archivos: state.data.archivos.filter(f => f.state !== 'r'),
          observaciones: state.data.observaciones.filter(f => f.state !== 'r'),
          etiquetas: state.data.etiquetas.filter(f => f.state !== 'r')
      },
      addRow: (dataTaggerType, row, success, error) => {
        switch(dataTaggerType) {
            case DATA_TAGGER_TYPE.ARCHIVO:
              AddArchivo(row, success, error);
              break;
            case DATA_TAGGER_TYPE.OBSERVACION:
              AddObservacion(row, success, error);
              break;
            case DATA_TAGGER_TYPE.ETIQUETA:
              AddEtiqueta(row, success, error);
              break;
            default:
                break;
        }
      },
      removeRow: (dataTaggerType, row, success, error) => {
        switch(dataTaggerType) {
          case DATA_TAGGER_TYPE.ARCHIVO:
            RemoveArchivo(row, success, error);
            break;
          case DATA_TAGGER_TYPE.OBSERVACION:
            RemoveObservacion(row, success, error);
            break;
          case DATA_TAGGER_TYPE.ETIQUETA:
            RemoveEtiqueta(row, success, error);
            break;
          default:
              break;
        }
      }
    });
  }, [state.entidad, state.idEntidad, state.data]);


  //callbacks
  const callbackNoSuccess = (response) => {
      response.json()
      .then((error) => {
          const message = error.message;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
          setState(prevState => {
              return {...prevState, loading: false};
          });
      })
      .catch((error) => {
          const message = 'Error procesando respuesta: ' + error;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
          setState(prevState => {
          return {...prevState, loading: false};
          });
      });
  }
  const callbackError = (error) => {
      const message = 'Error procesando solicitud: ' + error.message;
      ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
      setState(prevState => {
          return {...prevState, loading: false};
      });
  }
  const callbackSuccess = (response) => {
    response.json()
    .then((response) => {
      setState(prevState => {
          return {...prevState, loading: false};
      });
      SearchInformacionAdicional();
    })
    .catch((error) => {
      const message = 'Error procesando respuesta: ' + error;
      ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
      setState(prevState => {
        return {...prevState, loading: false};
      });
    });
  };

  //funciones
  function SearchInformacionAdicional() {

    setState(prevState => {
        return {...prevState, loading: true};
    });

    const callbackSearchInformacionAdicionalSuccess = (response) => {
        response.json()
        .then((data) => {
          data.archivos.forEach(x => {
              if (x.fecha) x.fecha = new Date(x.fecha);
          });
          data.observaciones.forEach(x => {
              if (x.fecha) x.fecha = new Date(x.fecha);
          });
          setState(prevState => {
              return {...prevState,
                loading: false,
                entidad: props.entidad,
                idEntidad: props.idEntidad,
                data: data
              };
          });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    };

    const paramsUrl = `/entidad/${props.entidad}/${props.idEntidad}`;
    ServerRequest(
        REQUEST_METHOD.GET,
        null,
        true,
        APIS.URLS.INFORMACION_ADICIONAL,
        paramsUrl,
        null,
        callbackSearchInformacionAdicionalSuccess,
        callbackNoSuccess,
        callbackError
    );

  }

  function AddArchivo(row, success, error) {

    setState(prevState => {
      return {...prevState, loading: true};
    });

    const dataBody = row;

    ServerRequest(
        REQUEST_METHOD.POST,
        null,
        true,
        APIS.URLS.ARCHIVO,
        null,
        dataBody,
        (response) => { callbackSuccess(response); success(); },
        (response) => { callbackNoSuccess(response); error(); },
        (error) => { callbackError(error); error(); }
    );

  }
  function RemoveArchivo(row, success, error) {

    setState(prevState => {
      return {...prevState, loading: true};
    });

    const paramUrl = `/${row.id}`;

    ServerRequest(
        REQUEST_METHOD.DELETE,
        null,
        true,
        APIS.URLS.ARCHIVO,
        paramUrl,
        null,
        (response) => { callbackSuccess(response); success(); },
        (response) => { callbackNoSuccess(response); error(); },
        (error) => { callbackError(error); error(); }
    );

  }
  function AddObservacion(row, success, error) {

    setState(prevState => {
      return {...prevState, loading: true};
    });

    const dataBody = row;

    ServerRequest(
        REQUEST_METHOD.POST,
        null,
        true,
        APIS.URLS.OBSERVACION,
        null,
        dataBody,
        (response) => { callbackSuccess(response); success(); },
        (response) => { callbackNoSuccess(response); error(); },
        (error) => { callbackError(error); error(); }
    );

  }
  function RemoveObservacion(row, success, error) {

    setState(prevState => {
      return {...prevState, loading: true};
    });

    const paramUrl = `/${row.id}`;

    ServerRequest(
        REQUEST_METHOD.DELETE,
        null,
        true,
        APIS.URLS.OBSERVACION,
        paramUrl,
        null,
        (response) => { callbackSuccess(response); success(); },
        (response) => { callbackNoSuccess(response); error(); },
        (error) => { callbackError(error); error(); }
    );

  }
  function AddEtiqueta(row, success, error) {

    setState(prevState => {
      return {...prevState, loading: true};
    });

    const dataBody = row;

    ServerRequest(
        REQUEST_METHOD.POST,
        null,
        true,
        APIS.URLS.ETIQUETA,
        null,
        dataBody,
        (response) => { callbackSuccess(response); success(); },
        (response) => { callbackNoSuccess(response); error(); },
        (error) => { callbackError(error); error(); }
    );

  }
  function RemoveEtiqueta(row, success, error) {

    setState(prevState => {
      return {...prevState, loading: true};
    });

    const paramUrl = `/${row.id}`;

    ServerRequest(
        REQUEST_METHOD.DELETE,
        null,
        true,
        APIS.URLS.ETIQUETA,
        paramUrl,
        null,
        (response) => { callbackSuccess(response); success(); },
        (response) => { callbackNoSuccess(response); error(); },
        (error) => { callbackError(error); error(); }
    );

  }


  const registro = props.registro || '';
  const sujeto = registro.startsWith('el ') ? `del ${registro.slice(3)}` : `de ${registro}`;
  const modalTitle = registro ? `Información adicional ${sujeto}` : props.title;

  return (
    <>

    <Loading visible={state.loading}></Loading>

    <div className='data-tagger-modal'>

      <Modal
        size="lg"
        title={modalTitle}
        tipName={props.tipName}
        onEscape={() => props.onDismiss()}
        body={(
              <DataTagger
                controller={controllerDataTagger}
                disabled={props.disabled}
                ocultarArchivos={props.ocultarArchivos}
              />
        )}
        footer={(
              <button className="btn back-button" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
        )}
        footerClassName="f-align"
      />

    </div>

    </>
  );
}

DataTaggerModalApi.propTypes = {
  disabled: bool,
  ocultarArchivos: bool,
  title: string.isRequired,
  registro: string,
  entidad: string.isRequired,
  idEntidad: number.isRequired,
  onDismiss: func.isRequired,
  tipName: string
};

DataTaggerModalApi.defaultProps = {
  disabled: false,
  registro: '',
  tipName: ''
};

export default DataTaggerModalApi;
